import React from 'react';

import { Typography, Row, Col } from 'antd';

import TreeSelectDropdown from './TreeSelectDropdown';
import NormSelectDropdown from './NormSelectDropdown';

import commonConfig from '../../../commonConfig.json';

const { Text } = Typography;
let dropDownConfigs = commonConfig.dropdownProps;


const CustomDropdown = props => {
    let label = <Text disabled={props.disabled} strong>{props.labelName}</Text>
    let dropDown = "";
    if(props.dropdownType === dropDownConfigs.dropdownType.SELECT){
        dropDown = <NormSelectDropdown {...props}></NormSelectDropdown>
    } else if(props.dropdownType === dropDownConfigs.dropdownType.TREESELECT){
        dropDown = <TreeSelectDropdown {...props}></TreeSelectDropdown>
    }
    if (props.labelPosition === dropDownConfigs.labelPosition.VERTICAL) {
            return(
                <Col span={24}>
                    {label}
                    {dropDown}
                </Col>
            )
    } else {
        return(
            <Row>
                <Col span={12}>
                    {label}
                </Col>
                <Col span={12}>
                    {dropDown}
                </Col>
            </Row>
        )
    }
}

export default React.memo(CustomDropdown);